function Header() {
  return (
    <div>
      <div className="fixed top-0 left-0 w-full bg-black">
        <div className="flex flex-row justify-between items-center text-white">
          <div>
            <img src="aq.jpg" alt="Portfolio" className=" max-w-12 lg:h-12 lg:w-20" />
          </div>
          <div>
            <ul className="list-none flex flex-row justify-center lg:visible sm:invisible ">
              <a href="#home">
                <li className="font-medium px-8 py-2 mr-50 rounded-lg hover:bg-gray-800">Home</li>
              </a>
              <a href="#about">
                <li className="font-medium px-8 py-2 mr-50 rounded-lg hover:bg-gray-800">About</li>
              </a>
              <a href="#services">
                <li className="font-medium px-8 py-2 mr-50 rounded-lg hover:bg-gray-800">Services</li>
              </a>
              <a href="#contact">
                <li className="font-medium px-8 py-2 mr-50 rounded-lg hover:bg-gray-800">Contact</li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
